@if (alertMessage) {
  <notification [timeout]="timeout" [severity]="alertType" [message]="alertMessage" (hideNotification)="alertMessage = null"></notification>
}

@if (userModalOpened) {
  <div tabindex="1" >
    <div aria-labelledby="ngl_modal_header_1" aria-hidden="false" role="dialog" [ngClass]="headerColorClass">
      <div class="slds-modal__container">
        <!-- Header -->
        <div class="slds-modal__header">
          <button type="button" nglbuttonicon="inverse" class="slds-modal__close slds-button slds-button--icon-inverse" (click)="close('CLOSE')">
            <i class="material-icons" style="font-size: 22px; top: -2px; left: -2px; margin: 0; cursor: pointer">&#xE5CD;</i  >
          </button>
          <h2 id="ngl_modal_header_1" class="slds-text-heading--medium">{{modalTitle}}</h2>
          @if (currentEvent.socialEventId !== 0) {
            <i  class="material-icons" (click)="redirectToEventInfo(currentEvent.socialEventId)">help_outline</i>
          }
          @if (isCurrentTypeValid(currentEvent.eventType) && !locked) {
            <button class="btn" (click)="manageEvent(modalButtonLabel, currentEvent.eventId)">{{modalButtonLabel}}</button>
          }
        </div>
        <!-- First input as header-->
        <div class="slds-modal__header_still">
          <input type="text"  [(ngModel)]="currentEvent.eventDesc" id="text" placeholder="Set a description" [disabled]="!isModalEditable" [style.padding-left]="getDescriptionStyle()" />
          @if ((isCurrentTypeValid(currentEvent.eventType) && currentEvent.eventStatus == 'VALIDATED' && !isModalEditable && !locked)) {
            <button
              class="btn-delete-event"
              (click)="manageEvent('DELETE', currentEvent.eventId)"
              title="Delete request">
              <i class="material-icons">delete</i>
            </button>
          }
        </div>
        <div class="slds-modal__content slds-p-around--medium" style="padding: 0 0 12px 0">
          <div>
            <form>
              <!-- Type event -->
              <div  id="type-event" class="btn-group event-container">
                @if (isEventTypeOf(currentEvent.eventType, 'OFF', isModalEditable)) {
                  <label (click)="eventTypeChange('OFF')" class="btn btn-modal-event btn-modal-event-off-duty" [class.active]="(currentEvent.eventType == 'OFF' && isModalEditable)" [class.not-editable]="!isModalEditable">
                    @if (isModalEditable) {
                      <input type="radio" autocomplete="off" id="option1" name="options">
                      } Off duty
                    </label>
                  }
                  @if (isEventTypeOf(currentEvent.eventType, 'SICK', isModalEditable)) {
                    <label (click)="eventTypeChange('SICK')" class="btn btn-modal-event btn-modal-event-sick" [class.active]="(currentEvent.eventType == 'SICK' && isModalEditable)" [class.not-editable]="!isModalEditable">
                      @if (isModalEditable) {
                        <input type="radio" autocomplete="off" id="option2" name="options">
                        } Sickness
                      </label>
                    }
                    @if (isEventTypeOf(currentEvent.eventType, 'KIDS', isModalEditable)) {
                      <label (click)="eventTypeChange('KIDS')" class="btn btn-modal-event btn-modal-event-kids" [class.active]="(currentEvent.eventType == 'KIDS' && isModalEditable)" [class.not-editable]="!isModalEditable">
                        @if (isModalEditable) {
                          <input type="radio" autocomplete="off" id="option3" name="options">
                          } Kids sickness
                        </label>
                      }
                      @if (isEventTypeOf(currentEvent.eventType, 'DOL', isModalEditable)) {
                        <label (click)="eventTypeChange('DOL')" class="btn btn-modal-event btn-modal-event-hbw" [class.active]="(currentEvent.eventType == 'DOL' && isModalEditable)" [class.not-editable]="!isModalEditable">
                          @if (isModalEditable) {
                            <input type="radio" autocomplete="off" id="option4" name="options">
                            } Outside Lux
                          </label>
                        }
                        @if (currentEvent.eventType == 'TRAIN') {
                          <label class="btn btn-modal-event btn-modal-event-train" [class.not-editable]="!isModalEditable">
                            @if (isModalEditable) {
                              <input type="radio" autocomplete="off" id="option5" name="options">
                              } Training
                            </label>
                          }
                          @if (currentEvent.eventType == 'OTH') {
                            <label class="btn btn-modal-event btn-modal-event-oth" [class.not-editable]="!isModalEditable">
                              @if (isModalEditable) {
                                <input type="radio" autocomplete="off" id="option6" name="options">
                                } Special event
                              </label>
                            }
                            @if (currentEvent.eventType == 'PHOL') {
                              <label  class="btn btn-modal-event btn-modal-event-phol" [class.not-editable]="!isModalEditable">
                                @if (isModalEditable) {
                                  <input type="radio" autocomplete="off" id="option7" name="options">
                                  } Public holiday
                                </label>
                              }
                              @if (currentEvent.eventType == 'CASUALZ') {
                                <label  class="btn btn-modal-event btn-modal-event-casualz" [class.not-editable]="!isModalEditable">
                                  @if (isModalEditable) {
                                    <input type="radio" autocomplete="off" id="option8" name="options">
                                    } Casual'z
                                  </label>
                                }
                                @if (currentEvent.eventType == 'TECHZ') {
                                  <label  class="btn btn-modal-event btn-modal-event-techz" [class.not-editable]="!isModalEditable">
                                    @if (isModalEditable) {
                                      <input type="radio" autocomplete="off" id="option9" name="options">
                                      } Tech'z
                                    </label>
                                  }
                                  @if (currentEvent.eventType == 'CONFZ') {
                                    <label  class="btn btn-modal-event btn-modal-event-confz" [class.not-editable]="!isModalEditable">
                                      @if (isModalEditable) {
                                        <input type="radio" autocomplete="off" id="option10" name="options">
                                        } Conf'z
                                      </label>
                                    }
                                    @if (currentEvent.eventType == 'TRAINZ') {
                                      <label  class="btn btn-modal-event btn-modal-event-trainz" [class.not-editable]="!isModalEditable">
                                        @if (isModalEditable) {
                                          <input type="radio" autocomplete="off" id="option11" name="options">
                                          } Train'z
                                        </label>
                                      }
                                    </div>
                                    <hr />
                                    <!-- All day switch -->
                                    <div class="form-group">
                                      <div class="input-group">
                                        <span class="input-group-addon"><i class="material-icons">access_time</i></span>
                                        <div class="togglebutton">
                                          <label [class.label-grey]="!allDay">
                                            All-Day @if (isModalEditable) {
                                            <input type="checkbox" id="all-day" [(ngModel)]="allDay" name="all-day" (change)="switchAllDayTag()">
                                          }
                                        </label>
                                      </div>
                                      @if (isModalEditable) {
                                        <label class="switch" style="position: absolute; right: 10px;">
                                          <input type="checkbox" [(ngModel)]="allDay"  name="all-day" (change)="switchAllDayTag()">
                                          <div class="slider round"></div>
                                        </label>
                                      }
                                    </div>
                                  </div>
                                  <!-- Start date -->
                                  <div class="form-group date-panel">
                                    <div class="input-group">
                                      <!-- Datepicker -->
                                      <div (appClickOutside)="onOutsideClickStart()" class="label-date" (click)="showStartDatePicker = isModalEditable">{{currentEvent.eventStartDate | dateFormat}}</div>
                                      @if (showStartDatePicker && isModalEditable) {
                                        <p-datepicker
                                          class="custom-p-calendar"
                                          [appendTo]="'body'"
                                          [selectOtherMonths]="true"
                                          name="startDate"
                                          [minDate]="minDate"
                                          [maxDate]="maxDate"
                                          [(ngModel)]="currentEvent.eventStartDate"
                                          [inline]="true"
                                          dateFormat='yy-mm-dd'
                                          dataType="string"
                                          (onSelect)="onStartDateSelect()">
                                        </p-datepicker>
                                      }
                                      <!-- AM/PM -->
                                      @if (isModalEditable) {
                                        <p-selectButton class="display-time" name="startPeriod" [class.hidden-allday]="allDay" [class.shown-allday]="!allDay" [options]="periods" [(ngModel)]="currentEvent.eventStartPeriod"></p-selectButton>
                                      }
                                      @if (!isModalEditable) {
                                        <div class="display-period" >
                                          @if (currentEvent.eventStartPeriod === 'AM') {
                                            <span class="time-span">morning</span>
                                          }
                                          @if (currentEvent.eventStartPeriod === 'PM') {
                                            <span class="time-span">afternoon</span>
                                          }
                                          @if (currentEvent.eventStartPeriod === 'AW') {
                                            <span class="time-span">afterwork</span>
                                          }
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <!-- End date -->
                                  @if (currentEvent.eventStartPeriod != 'AW') {
                                    <div class="form-group date-panel">
                                      <div class="input-group">
                                        <!-- Datepicker -->
                                        <div (appClickOutside)="onOutsideClickEnd()" class="label-date" (click)="showEndDatePicker = isModalEditable">{{currentEvent.eventEndDate | dateFormat}}</div>
                                        @if (showEndDatePicker && isModalEditable) {
                                          <p-datepicker
                                            class="custom-p-calendar"
                                            name="endDate"
                                            [selectOtherMonths]="true"
                                            [minDate]="minDate"
                                            [maxDate]="maxDate"
                                            [(ngModel)]="currentEvent.eventEndDate"
                                            [inline]="true"
                                            dateFormat='yy-mm-dd'
                                            dataType="string"
                                            (onSelect)="onEndDateSelect()">
                                          </p-datepicker>
                                        }
                                        <!-- AM/PM -->
                                        @if (isModalEditable) {
                                          <p-selectButton class="display-time" name="endPeriod" [class.hidden-allday]="allDay" [class.shown-allday]="!allDay" [options]="periods" [(ngModel)]="currentEvent.eventEndPeriod"></p-selectButton>
                                        }
                                        @if (!isModalEditable) {
                                          <div class="display-period">
                                            @if (currentEvent.eventEndPeriod === 'AM') {
                                              <span class="time-span">morning</span>
                                            }
                                            @if (currentEvent.eventEndPeriod === 'PM') {
                                              <span class="time-span">afternoon</span>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                  <!-- Event status -->
                                  @if ((isCurrentTypeValid(currentEvent.eventType) && !isModalEditable)) {
                                    <div class="form-group" style="margin-top: 7px; padding-top: 7px;">
                                      <div class="input-group" style="margin-left: 10px; margin-right: 10px">
                                        <span class="input-group-addon">
                                          @if (currentEvent.eventStatus == 'VALIDATED') {
                                            <i class="material-icons">&#xE876;</i>
                                          }
                                          @if (currentEvent.eventStatus == 'PENDING') {
                                            <i class="material-icons">&#xE889;</i>
                                          }
                                          @if (currentEvent.eventStatus == 'CORRECTED') {
                                            <i class="material-icons">&#xE3C9;</i>
                                          }
                                          @if (currentEvent.eventStatus == 'DELETED') {
                                            <i class="material-icons">&#xE92B;</i>
                                          }
                                        </span>
                                        @if (currentEvent.eventStatus == 'VALIDATED') {
                                          <label class="event-status">Validated</label>
                                        }
                                        @if (currentEvent.eventStatus == 'PENDING') {
                                          <label class="event-status">Pending - waiting for validation</label>
                                        }
                                        @if (currentEvent.eventStatus == 'CORRECTED') {
                                          <label class="event-status">Corrected - waiting for validation</label>
                                        }
                                        @if (currentEvent.eventStatus == 'DELETED') {
                                          <label class="event-status">Deletion requested - waiting for validation</label>
                                        }
                                      </div>
                                    </div>
                                  }
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="slds-backdrop slds-backdrop--open"></div>
                      </div>
                    }
